import { useQuery } from '@tanstack/react-query';

import { useCurrentUser } from '@/hooks/use-current-user';
import { useLookupsService } from '@/hooks/use-lookups-service';

/**
 * Hook to get classifications that are tracked by the current user's client.
 * For external users: Returns therapeutic classes that the client has purchased/is tracking.
 * For internal users: Returns all classifications without client-specific filters.
 */
export const useTrackedClassifications = () => {
  const { getClassifications } = useLookupsService();
  const { user } = useCurrentUser();

  return useQuery({
    queryKey: ['tracked-classifications', user.client?.id || 'internal'],
    queryFn: async () => {
      if (user.client?.id) {
        // External user - get classifications tracked by their client
        return await getClassifications({
          trackedByClients: [user.client.id],
          trackedOnly: true,
        });
      } else {
        // Internal user - get all classifications without client filters
        return await getClassifications({});
      }
    },
    enabled: !!user, // Enable for any authenticated user (internal or external)
  });
};
